/** Thananan Payroll's strings, the `payroll` namespace (payroll:compensation…, payroll:payroll…) */

export const th = {
  app: { name: 'Payroll', description: 'งวดเงินเดือน สลิป เบิกเงินล่วงหน้า ภาษีและประกันสังคม' },
  nav: {
    payrollRuns: 'งวดเงินเดือน',
    payslips: 'สลิปเงินเดือน',
    advances: 'เบิกเงินล่วงหน้า',
    people: 'พนักงาน',
    compensations: 'ค่าจ้างพนักงาน',
    payAdjustments: 'เงินเพิ่ม/เงินหัก',
    taxDeclarations: 'ค่าลดหย่อนภาษี',
    tax: 'ภาษีและประกันสังคม',
    filings: 'ยื่นประกันสังคมและภาษี',
    taxCertificates: 'หนังสือรับรองภาษี (50 ทวิ)',
    settings: 'ตั้งค่า',
    payItems: 'รายการเงินได้/เงินหัก',
    tripRates: 'อัตราค่าเที่ยว',
    fuelRates: 'ค่าน้ำมันต่อ กม.',
    payrollSettings: 'ตั้งค่าเงินเดือน',
  },
  overview: {
    title: 'ภาพรวม',
    toDecide: 'มีคำขอเบิกเงินรออนุมัติ {{count}} รายการ',
    toPay: 'อนุมัติแล้ว รอจ่าย {{count}} รายการ',
    runs: 'งวดที่ยังไม่ปิด',
    noRuns: 'ไม่มีงวดที่ค้างอยู่',
    newRun: 'สร้างงวดเงินเดือน',
    payDate: 'จ่าย {{date}}',
    missing: 'ยังไม่ได้ตั้งค่าจ้าง',
    missingHint: 'พนักงานที่ทำงานอยู่ แต่ยังไม่มีค่าจ้าง จะไม่ได้สลิปในงวด',
    startedOn: 'เริ่ม {{date}}',
    none: 'ไม่มี',
  },
  opening: {
    title: 'ยกยอดเริ่มต้น',
    hint: 'เริ่มใช้ระบบกลางปี: เงินเดือนสะสมของปีนี้จากโปรแกรมเก่าหรือ Excel ระบบตรวจทุกแถวก่อน แล้วค่อยบันทึกทั้งหมดพร้อมกัน',
    kinds: { payroll: 'เงินเดือนสะสมต้นปี' },
    kindHints: {
      payroll: 'เงินได้ ภาษีที่หัก และประกันสังคมของแต่ละคน ตั้งแต่ ม.ค. จนถึงก่อนสลิปแรกในระบบ ใช้คำนวณภาษีงวดที่เหลือและรวมใน 50 ทวิ',
    },
    col: {
      employeeCode: 'รหัสพนักงาน',
      income: 'เงินได้สะสม',
      tax: 'ภาษีที่หักแล้ว',
      sso: 'ประกันสังคมที่หักแล้ว',
    },
  },
  advance: {
    title: 'เบิกเงินล่วงหน้า',
    plural: 'เบิกเงินล่วงหน้า',
    create: 'เบิกแทนพนักงาน',
    fields: {
      number: 'เลขที่',
      employeeId: 'พนักงาน',
      amount: 'จำนวนเงิน',
      method: 'รับเงินทาง',
      reason: 'เหตุผล',
      status: 'สถานะ',
      available: 'เบิกได้ตอนขอ',
      userId: 'บัญชีผู้ใช้',
      branchId: 'สาขา',
      requestedByUserId: 'ขอโดย',
      requestedAt: 'ขอเมื่อ',
      reviewedByUserId: 'พิจารณาโดย',
      reviewedAt: 'พิจารณาเมื่อ',
      rejectReason: 'เหตุผลที่ไม่อนุมัติ',
      paidByUserId: 'จ่ายโดย',
      paidAt: 'จ่ายเมื่อ',
      paidMethod: 'จ่ายทาง',
      paidReference: 'เลขอ้างอิงการโอน',
      adjustmentId: 'รายการหักเงินเดือน',
    },
    options: {
      method: { cash: 'เงินสด', transfer: 'โอนเข้าบัญชี' },
      status: { pending: 'รออนุมัติ', approved: 'อนุมัติแล้ว รอจ่าย', paid: 'จ่ายแล้ว', rejected: 'ไม่อนุมัติ', cancelled: 'ยกเลิก' },
    },
    available: 'เบิกได้อีก {{amount}} บาท',
    availableHint: 'ไม่เกิน {{percent}}% ของค่าจ้างที่ทำมาแล้วในงวดนี้ ({{earned}} บาท) หักที่เบิกไปแล้ว {{taken}} บาท',
    deductHint: 'หักคืนจากเงินเดือนงวดที่จ่ายเงินเบิก',
    consent: 'ข้าพเจ้ายินยอมให้บริษัทหักเงินเดือนงวดที่จ่ายเงินเบิกนี้ เพื่อคืนเงินเบิกล่วงหน้า {{amount}} บาท',
    consentTitle: 'เซ็นยินยอมหักเงินเดือน',
    consentLabel: 'ลายเซ็นยินยอม',
    consentSigned: 'ยินยอมให้หักเงินเดือน',
    consentNone: 'ไม่มีลายเซ็นยินยอม (ขอเบิกก่อนมีระบบลายเซ็น หรือเบิกแทนโดยไม่ได้ให้เซ็น)',
    signOnDevice: 'ให้พนักงานเซ็นยินยอมบนเครื่องนี้ (ไม่บังคับ)',
    pay: {
      title: 'จ่ายเงินเบิก {{number}}',
      cash: 'จ่ายเงินสดจากเงินสดย่อยของฉัน',
      cashHint: 'เงินสดย่อยของคุณจะลดลง {{amount}} บาท ฝ่ายบัญชีจะเติมคืนตามรอบ',
      transfer: 'บันทึกว่าโอนแล้ว',
      reference: 'เลขอ้างอิงการโอน',
      done: 'บันทึกการจ่ายแล้ว ระบบจะหักคืนในงวดเงินเดือน',
    },
  },
  payroll: {
    earnings: 'รายได้',
    deductions: 'รายการหัก',
    gross: 'รวมรายได้',
    totalDeductions: 'รวมรายการหัก',
    net: 'รับสุทธิ',
    units: { day: '{{qty}} วัน', hour: '{{qty}} ชม.', minute: '{{qty}} นาที', trip: '{{qty}} เที่ยว', km: '{{qty}} กม.' },
    calculated: 'ระบบคิด {{amount}}',
    manual: 'เพิ่มเอง',
    editLine: 'แก้จำนวนเงิน',
    removeLine: 'เอาออก',
    ytdIncome: 'เงินได้สะสมทั้งปี',
    ytdTax: 'ภาษีสะสมทั้งปี',
    ytdSso: 'ประกันสังคมสะสมทั้งปี',
    trips: { title: 'เที่ยววิ่ง', driver: 'คนขับ', helper: 'ผู้ช่วย', km: '{{km}} กม.', noRate: 'ไม่มีอัตรา', lineHaul: 'เที่ยวรถ' },
    runs: { title: 'ค่าน้ำมันรอบส่ง', perKm: '{{rate}} บาท/กม.', noDistance: 'ยังไม่มีเลขไมล์', noRate: 'ไม่มีอัตรา' },
    doc: {
      title: 'สลิปเงินเดือน',
      confidential: 'เอกสารเฉพาะบุคคล',
      employee: 'พนักงาน',
      position: 'ตำแหน่ง',
      idCard: 'เลขบัตรประชาชน',
      period: 'ช่วงเวลา',
      payDate: 'วันจ่าย',
      paidTo: 'จ่ายเข้า',
      cash: 'เงินสด',
      amount: 'จำนวนเงิน',
      inWords: 'รับสุทธิ (ตัวอักษร)',
      taxId: 'เลขประจำตัวผู้เสียภาษี',
    },
    certificate: { title: 'หนังสือรับรองการหักภาษี ณ ที่จ่าย' },
    run: {
      newTitle: 'เปิดงวดเงินเดือน',
      newHint: 'งวดปกติเดือนละงวด ทุกคนทั้งรายเดือนและรายวัน ระบบคำนวณสลิปให้ทันที',
      specialHint: 'จ่ายเฉพาะช่วงวันหรือเฉพาะบางคน เช่น ค่าจ้างช่วงเปลี่ยนวันตัดรอบ โบนัส เงินงวดสุดท้ายของคนลาออก',
      month: 'เดือน',
      taken: 'มีงวดปกติของเดือนนี้แล้ว',
      countFrom: 'เริ่มนับเวลาทำงาน',
      regularPeriod: 'นับเวลาทำงาน {{from}} – {{to}} · เงินเดือนประจำคิดเดือน{{month}}',
      afterPrevious: 'ต่อจากงวด{{name}}',
      firstRun: 'งวดแรกในระบบ: วันก่อนหน้านี้จ่ายจากโปรแกรมเดิมแล้ว ปรับวันเริ่มได้',
      titleHint: 'เช่น ค่าจ้าง 26–31 ธ.ค., โบนัสสิ้นปี',
      countsTimeOn: 'จ่ายค่าจ้างรายวัน OT ขาด ลา สาย และค่าเที่ยวของวันในช่วงนี้ที่ยังไม่ได้นับในงวดอื่น',
      countsTimeOff: 'ไม่นับเวลา จ่ายเฉพาะรายการที่เพิ่มเองในสลิป (โบนัส เงินอื่นๆ)',
      extrasOnly: 'จ่ายเฉพาะรายการที่เพิ่ม',
      period: 'เวลาทำงาน {{from}} – {{to}}',
      create: 'เปิดงวดและคำนวณ',
      missing: 'ยังไม่ได้ตั้งค่าจ้าง {{count}} คน',
      missingHint: 'คนเหล่านี้ยังไม่อยู่ในงวดนี้ ตั้งค่าจ้างแล้วกดคำนวณใหม่',
      problems: 'มี {{count}} คนที่ต้องตรวจก่อนส่งอนุมัติ',
      changes: {
        title: 'เทียบกับเดือน{{name}}',
        none: 'คนเดิมทั้งหมด ค่าจ้างและวิธีรับเงินเหมือนเดือนก่อน',
        hint: 'ยอดสุทธิของแต่ละคนขึ้นลงตามวันทำงาน OT และค่าเที่ยวอยู่แล้ว ที่ควรตรวจคือรายการเหล่านี้',
        joined: 'เข้าใหม่ {{count}} คน',
        left: 'ไม่อยู่ในงวดนี้ {{count}} คน',
        rates: 'ค่าจ้างเปลี่ยน {{count}} คน',
        accounts: 'เปลี่ยนวิธีรับเงินหรือบัญชี {{count}} คน',
      },
      empty: 'ยังไม่มีพนักงานในงวดนี้',
      actions: {
        calculate: 'คำนวณใหม่',
        submit: 'ส่งอนุมัติ',
        approve: 'อนุมัติ',
        reopen: 'เปิดแก้ไข',
        pay: 'บันทึกว่าจ่ายแล้ว',
        print: 'พิมพ์สลิปทั้งหมด',
      },
      confirm: {
        calculate: 'คำนวณงวด {{name}} ใหม่?',
        calculateBody: 'ใช้เวลาทำงาน ใบลา OT และงานขนส่งล่าสุด รายการที่เพิ่มเองและจำนวนที่แก้ไว้ยังอยู่เหมือนเดิม',
        submit: 'ส่งงวด {{name}} ให้ผู้จัดการอนุมัติ?',
        submitBody: 'พนักงาน {{count}} คน ยอดจ่ายสุทธิ {{net}} บาท ส่งแล้วแก้ไม่ได้จนกว่าจะเปิดแก้ไข',
        approve: 'อนุมัติงวด {{name}}?',
        approveBody: 'พนักงาน {{count}} คนจะเห็นสลิปใน Thananan OS ยอดจ่ายสุทธิรวม {{net}} บาท',
        reopen: 'เปิดงวด {{name}} กลับมาแก้ไข',
        reason: 'เหตุผล',
        pay: 'บันทึกว่าจ่ายงวด {{name}} แล้ว',
        paidAt: 'วันที่จ่าย',
      },
      done: {
        calculated: 'คำนวณใหม่แล้ว',
        submitted: 'ส่งอนุมัติแล้ว',
        approved: 'อนุมัติแล้ว พนักงานเห็นสลิปแล้ว',
        reopened: 'เปิดแก้ไขแล้ว',
        paid: 'บันทึกว่าจ่ายแล้ว',
      },
      export: {
        bankFile: 'ไฟล์โอนเงินเดือน',
        code: 'รหัสพนักงาน',
        name: 'ชื่อ-นามสกุล',
        bank: 'ธนาคาร',
        account: 'เลขบัญชี',
        amount: 'จำนวนเงิน',
      },
    },
    slip: {
      addLine: 'เพิ่มรายการ',
      item: 'รายการ',
      amount: 'จำนวนเงิน',
      note: 'หมายเหตุ',
      restore: 'ใส่กลับ',
      print: 'พิมพ์สลิป',
      details: 'รายละเอียด',
      attendance: 'เวลาทำงาน',
      openTimesheet: 'ดูเวลาทำงานเดือนนี้',
      yearToDate: 'สะสมทั้งปี (รวมสลิปนี้)',
      editTitle: 'แก้ {{name}}',
      tripTitle: 'ค่าเที่ยวงาน {{number}}',
      runTitle: 'ค่าน้ำมันรอบส่ง {{number}}',
      useCalculated: 'ใช้ตามที่ระบบคิด ({{amount}})',
    },
    certificates: { hint: 'รวมสลิปที่อนุมัติแล้วของปีภาษี ใช้ให้พนักงานยื่นภาษีและแนบ ภ.ง.ด.1ก' },
    filings: {
      hint: 'ประกันสังคมนับตามเดือนของค่าจ้าง ภาษีนับตามเดือนที่จ่าย รวมเฉพาะงวดที่อนุมัติแล้ว',
      notReady: 'มี {{count}} งวดในเดือนนี้ที่ยังไม่อนุมัติ ยอดของงวดเหล่านี้ยังไม่รวม',
      ssoTitle: 'ประกันสังคม (สปส.1-10)',
      taxTitle: 'ภาษีหัก ณ ที่จ่าย (ภ.ง.ด.1)',
      insured: 'ผู้ประกันตน',
      wages: 'ค่าจ้างที่ใช้คำนวณ',
      employeeShare: 'เงินสมทบลูกจ้าง',
      bothShares: 'รวมนายจ้างและลูกจ้าง',
      payees: 'ผู้มีเงินได้',
      income: 'เงินได้ที่จ่าย',
      tax: 'ภาษีที่หัก',
      excel: 'ดาวน์โหลด Excel',
      text: 'ไฟล์ข้อความสำหรับ e-Service',
      textHint: 'ไฟล์ข้อความทำตามรูปแบบที่มีเผยแพร่ ไม่ใช่คู่มือทางการ ครั้งแรกให้ตรวจรายการในหน้า e-Service ก่อนยืนยัน',
      noIdCard: 'ยังไม่มีเลขบัตรประชาชน: {{names}}',
      noAccount: 'ยังไม่ได้ใส่เลขที่บัญชีนายจ้างของประกันสังคม',
      ssoDue: 'นำส่งภายใน {{date}}',
      taxDue: 'ยื่นภายใน {{date}} (ยื่นออนไลน์ได้ถึง {{online}})',
      basis: 'ข้อมูล ณ วันที่ {{end}} จากงวดที่อนุมัติหรือจ่ายแล้ว',
      col: {
        no: 'ลำดับ',
        idCard: 'เลขประจำตัวประชาชน',
        taxId: 'เลขประจำตัวผู้เสียภาษีอากร',
        title: 'คำนำหน้าชื่อ',
        firstName: 'ชื่อ',
        lastName: 'ชื่อสกุล',
        wage: 'ค่าจ้าง',
        contribution: 'เงินสมทบ',
        payDate: 'วันเดือนปีที่จ่าย',
        income: 'จำนวนเงินได้ที่จ่าย',
        tax: 'จำนวนเงินภาษีที่หัก',
        condition: 'เงื่อนไข',
      },
    },
  },
  compensation: {
    title: 'ค่าจ้าง',
    plural: 'ค่าจ้างพนักงาน',
    create: 'ตั้งค่าจ้าง',
    fields: {
      employeeId: 'พนักงาน',
      payBasis: 'จ่ายแบบ',
      rate: 'อัตรา (บาท)',
      payMethod: 'วิธีจ่าย',
      bank: 'ธนาคาร',
      bankAccount: 'เลขบัญชี',
      bankAccountName: 'ชื่อบัญชี',
      socialSecurity: 'หักประกันสังคม',
      withholdTax: 'หักภาษี ณ ที่จ่าย',
      bondTarget: 'เป้าเงินประกัน (บาท)',
      bondPerRun: 'หักเงินประกันงวดละ (บาท)',
      branchId: 'สาขา',
      notes: 'หมายเหตุ',
    },
    options: {
      payBasis: { monthly: 'รายเดือน', daily: 'รายวัน' },
      payMethod: { transfer: 'โอนเข้าบัญชี', cash: 'เงินสด' },
    },
    sections: { main: 'ค่าจ้าง', bank: 'การจ่ายเงิน', deductions: 'การหัก', bond: 'เงินประกัน' },
    rateHint: { monthly: 'บาทต่อเดือน', daily: 'บาทต่อวันที่มาทำงาน (จ่ายทุก 15 วัน)' },
    privateHint: 'เห็นได้เฉพาะฝ่ายเงินเดือนและผู้จัดการ',
    bankFromApplication: 'ใส่บัญชีธนาคารจากใบสมัครงานให้แล้ว ตรวจกับรูปหน้าสมุดบัญชีในข้อมูลพนักงาน',
    none: 'ยังไม่ได้ตั้งค่าจ้าง',
  },
  payItem: {
    title: 'รายการเงินได้และเงินหัก',
    plural: 'รายการเงินได้และเงินหัก',
    create: 'เพิ่มรายการ',
    fields: {
      code: 'รหัส',
      name: 'ชื่อ',
      kind: 'ประเภท',
      taxable: 'นับเป็นเงินได้ที่ต้องเสียภาษี',
      wage: 'นับเป็นค่าจ้างประกันสังคม',
      irregular: 'เงินได้ไม่ประจำ (โบนัส ค่าชดเชย)',
      system: 'ระบบคำนวณ',
      status: 'สถานะ',
      sortOrder: 'ลำดับ',
      notes: 'หมายเหตุ',
    },
    options: { kind: { earning: 'เงินได้', deduction: 'เงินหัก' }, status: { active: 'ใช้งาน', inactive: 'เลิกใช้' } },
    hint: 'รายการหักที่ติ๊ก "เงินได้ที่ต้องเสียภาษี" หรือ "ค่าจ้างประกันสังคม" จะลดฐานนั้นลง เช่น หักขาดงาน ส่วนรายการที่ไม่ติ๊กจะหักหลังคำนวณภาษี เช่น เงินเบิกล่วงหน้า',
  },
  payAdjustment: {
    title: 'เงินเพิ่ม/เงินหัก',
    plural: 'เงินเพิ่มและเงินหักรายคน',
    create: 'เพิ่มเงินเพิ่ม/เงินหัก',
    fields: {
      employeeId: 'พนักงาน',
      payItemId: 'รายการ',
      amount: 'จำนวนเงิน',
      repeat: 'ความถี่',
      date: 'วันที่',
      endDate: 'ถึงเดือน',
      branchId: 'สาขา',
      createdByUserId: 'บันทึกโดย',
      notes: 'หมายเหตุ',
    },
    options: { repeat: { once: 'ครั้งเดียว', monthly: 'ทุกเดือน' } },
    hint: 'ครั้งเดียว: เข้างวดที่มีวันที่นี้ · ทุกเดือน: เข้าทุกงวดสิ้นเดือนตั้งแต่เดือนของวันที่ จนถึงเดือนที่กำหนด (ว่างไว้คือไม่มีกำหนด)',
  },
  tripRate: {
    title: 'อัตราค่าเที่ยว',
    plural: 'อัตราค่าเที่ยว',
    create: 'เพิ่มอัตราค่าเที่ยว',
    fields: {
      vehicleType: 'ประเภทรถ',
      fromKm: 'ระยะทางตั้งแต่ (กม.)',
      driverAmount: 'คนขับ (บาท/เที่ยว)',
      helperAmount: 'ผู้ช่วย (บาท/เที่ยว)',
      notes: 'หมายเหตุ',
    },
    anyVehicle: 'รถทุกประเภท',
    hint: 'แต่ละแถวใช้ตั้งแต่ระยะทางนี้จนถึงแถวถัดไปของรถประเภทเดียวกัน ประเภทรถที่ไม่มีแถวของตัวเองใช้แถว "รถทุกประเภท" นับเฉพาะงานที่ส่งเสร็จในงวด',
  },
  fuelRate: {
    title: 'ค่าน้ำมันต่อ กม.',
    plural: 'ค่าน้ำมันต่อ กม.',
    create: 'เพิ่มอัตราค่าน้ำมัน',
    fields: { vehicleType: 'ประเภทรถ', perKm: 'บาทต่อ กม.', notes: 'หมายเหตุ' },
    hint: 'ระยะทางของรอบส่งมาจากเลขไมล์ที่คนขับถ่ายตอนออกรถและกลับถึงสาขา คูณอัตราของประเภทรถ ประเภทที่ไม่มีแถวของตัวเองใช้แถว "รถทุกประเภท" พนักงานได้เป็นค่าน้ำมันในสลิป รถร่วมได้เป็นอีกบรรทัดในบิลของรอบ',
  },
  payrollRun: {
    title: 'งวดเงินเดือน',
    plural: 'งวดเงินเดือน',
    create: 'เปิดงวดใหม่',
    fields: {
      name: 'งวด',
      kind: 'ประเภท',
      month: 'เดือน',
      periodStart: 'ตั้งแต่',
      periodEnd: 'ถึง',
      title: 'ชื่องวด',
      people: 'จ่ายให้',
      employeeIds: 'พนักงาน',
      countsTime: 'นับเวลาทำงาน',
      payDate: 'วันจ่าย',
      status: 'สถานะ',
      employeeCount: 'คน',
      gross: 'รวมรายได้',
      deductions: 'รวมรายการหัก',
      net: 'จ่ายสุทธิ',
      calculatedAt: 'คำนวณเมื่อ',
      submittedByUserId: 'ส่งอนุมัติโดย',
      submittedAt: 'ส่งอนุมัติเมื่อ',
      approvedByUserId: 'อนุมัติโดย',
      approvedAt: 'อนุมัติเมื่อ',
      paidAt: 'จ่ายเมื่อ',
      createdByUserId: 'สร้างโดย',
      notes: 'หมายเหตุ',
    },
    options: {
      kind: { regular: 'งวดปกติ', special: 'งวดพิเศษ' },
      people: { all: 'ทุกคน', daily: 'รายวัน', chosen: 'เลือกคน' },
      status: { draft: 'กำลังทำ', pending: 'รออนุมัติ', approved: 'อนุมัติแล้ว', paid: 'จ่ายแล้ว' },
    },
  },
  payslip: {
    title: 'สลิปเงินเดือน',
    plural: 'สลิปเงินเดือน',
    fields: {
      runId: 'งวด',
      employeeId: 'พนักงาน',
      userId: 'บัญชีผู้ใช้',
      branchId: 'สาขา',
      payBasis: 'จ่ายแบบ',
      rate: 'อัตรา',
      days: 'วัน',
      actualFrom: 'นับเวลาตั้งแต่',
      actualThrough: 'นับเวลาถึง',
      ahead: 'จ่ายล่วงหน้าตามตาราง',
      gross: 'รวมรายได้',
      deductions: 'รวมรายการหัก',
      net: 'จ่ายสุทธิ',
      taxable: 'เงินได้ที่ต้องเสียภาษี',
      ssoWage: 'ค่าจ้างประกันสังคม',
      sso: 'ประกันสังคม',
      tax: 'ภาษี',
      lines: 'รายการ',
      trips: 'เที่ยววิ่ง',
      runs: 'รอบส่ง',
      removed: 'รายการที่เอาออก',
      problems: 'ต้องตรวจ',
      ytdTaxable: 'เงินได้สะสม',
      ytdTax: 'ภาษีสะสม',
      ytdSso: 'ประกันสังคมสะสม',
      payMethod: 'วิธีจ่าย',
      bank: 'ธนาคาร',
      bankAccount: 'เลขบัญชี',
      status: 'สถานะ',
      payDate: 'วันจ่าย',
      notes: 'หมายเหตุ',
    },
    problems: {
      noBankAccount: 'ยังไม่มีเลขบัญชี',
      noTrips: 'ไม่มีเที่ยววิ่งในงวดนี้',
      unratedTrip: 'มีเที่ยวที่ไม่มีอัตราค่าเที่ยว',
      noDistance: 'มีรอบส่งที่ยังไม่มีเลขไมล์ จึงยังไม่มีค่าน้ำมัน',
      unratedRun: 'มีรอบส่งที่ไม่มีอัตราค่าน้ำมันของรถประเภทนั้น',
      overDeduction: 'หักเกิน 1 ใน 5 ของรายได้ (มาตรา 76)',
      negativeNet: 'ยอดสุทธิติดลบ',
      incomplete: 'มีวันที่ลงเวลาไม่ครบ',
      noIdCard: 'ยังไม่มีเลขบัตรประชาชน (ใช้ยื่นภาษีและประกันสังคม)',
      cashHeld: 'งวดสุดท้าย แต่ยังถือเงินต้องนำส่งหรือเงินสดย่อยอยู่: ให้คืนก่อนอนุมัติ',
      bondNoAccount: 'ตั้งเป้าเงินประกันไว้ แต่ยังไม่มีบัญชีถือเงิน จึงยังไม่หัก (สร้างได้ที่ข้อมูลพนักงานในแอพ HR)',
      bondLate: 'วันจ่ายช้ากว่า 7 วันหลังวันทำงานวันสุดท้าย: ให้ฝ่ายบัญชีคืนเงินประกันก่อน (มาตรา 10) แล้วคำนวณใหม่',
    },
  },
  taxDeclaration: {
    title: 'ค่าลดหย่อนภาษี',
    plural: 'ค่าลดหย่อนภาษี (ล.ย.01)',
    create: 'เพิ่มค่าลดหย่อน',
    fields: {
      employeeId: 'พนักงาน',
      year: 'ปีภาษี',
      spouse: 'คู่สมรสไม่มีเงินได้',
      children: 'บุตร (คน)',
      childrenFrom2018: 'ในนั้น เป็นบุตรคนที่ 2 ขึ้นไปที่เกิดตั้งแต่ปี 2561',
      parents: 'บิดามารดาของตนเองและคู่สมรส อายุ 60 ปีขึ้นไป (คน)',
      disabled: 'ผู้พิการหรือทุพพลภาพที่อุปการะ (คน)',
      lifeInsurance: 'เบี้ยประกันชีวิต',
      healthInsurance: 'เบี้ยประกันสุขภาพตนเอง',
      parentsHealthInsurance: 'เบี้ยประกันสุขภาพบิดามารดา',
      providentFund: 'เงินสะสมกองทุนสำรองเลี้ยงชีพ',
      homeLoanInterest: 'ดอกเบี้ยเงินกู้ซื้อที่อยู่อาศัย',
      other: 'ลดหย่อนอื่น (RMF, ThaiESG, เงินบริจาค…)',
      openingIncome: 'เงินได้ที่จ่ายไปแล้ว',
      openingTax: 'ภาษีที่หักไปแล้ว',
      openingSso: 'ประกันสังคมที่หักไปแล้ว',
      total: 'ลดหย่อนรวม',
      userId: 'บัญชีผู้ใช้',
      notes: 'หมายเหตุ',
    },
    sections: { main: 'ค่าลดหย่อน', family: 'ครอบครัว', insurance: 'ประกันและกองทุน', other: 'อื่นๆ', opening: 'ยอดยกมา (ฝ่ายเงินเดือน)' },
    openingHint: 'ใส่เมื่อเริ่มใช้ระบบกลางปี: ยอดที่บริษัทจ่ายและหักไปแล้วตั้งแต่ ม.ค. ของปีนี้ จนถึงก่อนสลิปแรกในระบบ ใช้คำนวณภาษีและรวมใน 50 ทวิ',
    hint: 'ระบบนับค่าลดหย่อนส่วนตัว 60,000 บาท ค่าใช้จ่าย 50% (ไม่เกิน 100,000 บาท) และประกันสังคมให้เองแล้ว',
  },
  payrollSetting: {
    title: 'ตั้งค่าเงินเดือน',
    fields: {
      ssoRate: 'อัตราเงินสมทบประกันสังคม (%)',
      ssoMinWage: 'ค่าจ้างขั้นต่ำที่ใช้คำนวณ',
      ssoMaxWage: 'ค่าจ้างสูงสุดที่ใช้คำนวณ',
      ssoAccount: 'เลขที่บัญชีนายจ้าง (ประกันสังคม)',
      ssoBranch: 'ลำดับที่สาขา',
      cutoffDay: 'วันตัดรอบ (วันที่)',
      deductLate: 'หักเงินเมื่อมาสาย (คิดเป็นนาที เฉพาะรายเดือน)',
      advancePercent: 'เบิกล่วงหน้าได้ไม่เกิน (% ของค่าจ้างที่ทำมาแล้ว)',
    },
    sections: { run: 'งวดเงินเดือน', sso: 'ประกันสังคม', time: 'เวลาทำงาน', advance: 'เบิกเงินล่วงหน้า' },
    sectionHints: {
      run: 'จ่ายเดือนละงวดทุกคน เงินเดือนประจำคิดทั้งเดือน ส่วนที่คิดตามเวลา (ค่าจ้างรายวัน OT ขาด ลา สาย ค่าเที่ยว) นับถึงวันตัดรอบ เว้นว่าง = สิ้นเดือน เช่น 25: นับ 26 เดือนก่อน – 25 เดือนนี้ เปลี่ยนแล้วงวดถัดไปนับต่อจากงวดก่อนเอง',
    },
    hint: 'ปี 2569–2571 ค่าจ้างสูงสุดที่ใช้คำนวณ 17,500 บาท (หักสูงสุด 875 บาทต่อเดือน)',
  },
} as const

export const en = {
  app: { name: 'Payroll', description: 'Pay runs, payslips, salary advances, tax and social security' },
  nav: {
    payrollRuns: 'Pay runs',
    payslips: 'Payslips',
    advances: 'Salary advances',
    people: 'Employees',
    compensations: 'Employee pay',
    payAdjustments: 'Extras and deductions',
    taxDeclarations: 'Tax allowances',
    tax: 'Tax and social security',
    filings: 'Social security and tax filings',
    taxCertificates: 'Tax certificates (50 bis)',
    settings: 'Settings',
    payItems: 'Earnings and deductions',
    tripRates: 'Trip rates',
    fuelRates: 'Fuel per km',
    payrollSettings: 'Payroll settings',
  },
  overview: {
    title: 'Overview',
    toDecide: '{{count}} salary advance requests waiting for approval',
    toPay: '{{count}} approved, waiting to be paid',
    runs: 'Open pay runs',
    noRuns: 'No pay run is open',
    newRun: 'New pay run',
    payDate: 'Paid {{date}}',
    missing: 'No pay set',
    missingHint: 'At work but without pay set: they get no payslip in a run',
    startedOn: 'Started {{date}}',
    none: 'None',
  },
  opening: {
    title: 'Brought forward',
    hint: "Starting mid-year: this year's pay so far from the old program or a spreadsheet. Every row is checked first, then all are saved together",
    kinds: { payroll: 'Pay so far this year' },
    kindHints: {
      payroll:
        "Each person's income, tax withheld and social security from January to their first payslip here, for the tax of the runs left and the 50 bis",
    },
    col: {
      employeeCode: 'Employee code',
      income: 'Income so far',
      tax: 'Tax withheld',
      sso: 'Social security',
    },
  },
  advance: {
    title: 'Salary advance',
    plural: 'Salary advances',
    create: 'Ask for someone',
    fields: {
      number: 'No.',
      employeeId: 'Employee',
      amount: 'Amount',
      method: 'Paid by',
      reason: 'Reason',
      status: 'Status',
      available: 'Available when asked',
      userId: 'User account',
      branchId: 'Branch',
      requestedByUserId: 'Asked by',
      requestedAt: 'Asked',
      reviewedByUserId: 'Decided by',
      reviewedAt: 'Decided',
      rejectReason: 'Reason for rejecting',
      paidByUserId: 'Paid by',
      paidAt: 'Paid',
      paidMethod: 'Paid with',
      paidReference: 'Transfer reference',
      adjustmentId: 'Payroll deduction',
    },
    options: {
      method: { cash: 'Cash', transfer: 'Bank transfer' },
      status: { pending: 'Awaiting approval', approved: 'Approved, to pay', paid: 'Paid', rejected: 'Rejected', cancelled: 'Cancelled' },
    },
    available: '{{amount}} THB available',
    availableHint: 'Up to {{percent}}% of the pay earned this period ({{earned}} THB), less {{taken}} THB already asked for',
    deductHint: 'Taken back from the pay run of the day it is paid',
    consent: 'I agree to the company taking this advance of {{amount}} baht back from the pay of the run it is paid in',
    consentTitle: 'Sign to agree to the deduction',
    consentLabel: 'Signed agreement',
    consentSigned: 'Agreed to the deduction',
    consentNone: 'No signed agreement (asked before signatures, or asked for without one)',
    signOnDevice: 'Let the employee sign on this device (optional)',
    pay: {
      title: 'Pay advance {{number}}',
      cash: 'Pay cash from my petty cash',
      cashHint: 'Your petty cash goes down by {{amount}} THB; accounting tops it up as usual',
      transfer: 'Record as transferred',
      reference: 'Transfer reference',
      done: 'Paid: it is deducted in the pay run',
    },
  },
  payroll: {
    earnings: 'Earnings',
    deductions: 'Deductions',
    gross: 'Gross',
    totalDeductions: 'Total deductions',
    net: 'Net pay',
    units: { day: '{{qty}} days', hour: '{{qty}} h', minute: '{{qty}} min', trip: '{{qty}} trips', km: '{{qty}} km' },
    calculated: 'Calculated {{amount}}',
    manual: 'Added',
    editLine: 'Change amount',
    removeLine: 'Remove',
    ytdIncome: 'Income this year',
    ytdTax: 'Tax this year',
    ytdSso: 'Social security this year',
    trips: { title: 'Trips', driver: 'Driver', helper: 'Helper', km: '{{km}} km', noRate: 'No rate', lineHaul: 'Branch trip' },
    runs: { title: 'Delivery run fuel', perKm: 'THB {{rate}}/km', noDistance: 'No odometer yet', noRate: 'No rate' },
    doc: {
      title: 'Payslip',
      confidential: 'Private and confidential',
      employee: 'Employee',
      position: 'Position',
      idCard: 'ID card no.',
      period: 'Period',
      payDate: 'Pay day',
      paidTo: 'Paid to',
      cash: 'Cash',
      amount: 'Amount',
      inWords: 'Net pay in words',
      taxId: 'Tax ID',
    },
    certificate: { title: 'Withholding tax certificate' },
    run: {
      newTitle: 'New pay run',
      newHint: 'One regular run a month for everyone, monthly staff and day workers, calculated straight away',
      specialHint: 'Pays a stretch of days or some people only: the days around a new cut-off, a bonus, a leaver’s last pay',
      month: 'Month',
      taken: 'This month already has its regular run',
      countFrom: 'Count time from',
      regularPeriod: 'Time {{from}} – {{to}} · salaries for {{month}}',
      afterPrevious: 'Goes on from {{name}}',
      firstRun: 'The first run here: the days before were paid by the old program. The start can be changed.',
      titleHint: 'e.g. Wages 26–31 Dec, Year-end bonus',
      countsTimeOn: 'Pays day wages, overtime, absence, leave, lateness and trips of its days not counted in another run',
      countsTimeOff: 'No time counted: pays only what is added to the payslips (a bonus, other pay)',
      extrasOnly: 'Pays only what is added',
      period: 'Time {{from}} – {{to}}',
      create: 'Create and calculate',
      missing: '{{count}} without pay set',
      missingHint: 'They are not in this run yet: set their pay, then calculate again',
      problems: '{{count}} to check before submitting',
      changes: {
        title: 'Compared with {{name}}',
        none: 'The same people, with the same pay and way of being paid as the month before',
        hint: 'Net pay moves with days worked, overtime and trips anyway: these are what to check',
        joined: '{{count}} new',
        left: '{{count}} not in this run',
        rates: '{{count}} with a new rate',
        accounts: '{{count}} paid another way or to another account',
      },
      empty: 'Nobody is in this run yet',
      actions: {
        calculate: 'Calculate again',
        submit: 'Submit',
        approve: 'Approve',
        reopen: 'Reopen',
        pay: 'Record as paid',
        print: 'Print all payslips',
      },
      confirm: {
        calculate: 'Calculate {{name}} again?',
        calculateBody: 'From the latest time, leave, overtime and jobs. Added lines and changed amounts stay',
        submit: 'Submit {{name}} for approval?',
        submitBody: '{{count}} people, {{net}} THB net. It cannot be changed until reopened',
        approve: 'Approve {{name}}?',
        approveBody: '{{count}} people will see their payslips in Thananan OS. Net pay {{net}} THB',
        reopen: 'Reopen {{name}}',
        reason: 'Reason',
        pay: 'Record {{name}} as paid',
        paidAt: 'Paid on',
      },
      done: {
        calculated: 'Calculated again',
        submitted: 'Submitted',
        approved: 'Approved: payslips are out',
        reopened: 'Reopened',
        paid: 'Recorded as paid',
      },
      export: {
        bankFile: 'Bank transfer file',
        code: 'Employee code',
        name: 'Full name',
        bank: 'Bank',
        account: 'Account no.',
        amount: 'Amount',
      },
    },
    slip: {
      addLine: 'Add line',
      item: 'Item',
      amount: 'Amount',
      note: 'Note',
      restore: 'Bring back',
      print: 'Print payslip',
      details: 'Details',
      attendance: 'Working time',
      openTimesheet: "See this month's time",
      yearToDate: 'This year (with this payslip)',
      editTitle: 'Change {{name}}',
      tripTitle: 'Trip pay for {{number}}',
      runTitle: 'Fuel for run {{number}}',
      useCalculated: 'Use calculated ({{amount}})',
    },
    certificates: { hint: "The year's approved payslips, for the employee's tax return and P.N.D.1 Kor" },
    filings: {
      hint: 'Social security by the month wages are for, tax by the month they are paid; approved runs only',
      notReady: '{{count}} runs this month are not approved yet and are left out',
      ssoTitle: 'Social security (SSO 1-10)',
      taxTitle: 'Withholding tax (P.N.D.1)',
      insured: 'Insured people',
      wages: 'Wages counted',
      employeeShare: "Employees' share",
      bothShares: 'Employer and employees',
      payees: 'Payees',
      income: 'Income paid',
      tax: 'Tax withheld',
      excel: 'Download Excel',
      text: 'Text file for e-Service',
      textHint:
        'The text file follows a published layout, not an official manual: check the list on e-Service before confirming the first time',
      noIdCard: 'No ID card number: {{names}}',
      noAccount: 'No employer social security account set',
      ssoDue: 'Due by {{date}}',
      taxDue: 'Due by {{date}} ({{online}} online)',
      basis: 'As of {{end}}, from approved or paid runs',
      col: {
        no: 'No.',
        idCard: 'ID card no.',
        taxId: 'Tax ID',
        title: 'Title',
        firstName: 'First name',
        lastName: 'Surname',
        wage: 'Wage',
        contribution: 'Contribution',
        payDate: 'Paid on',
        income: 'Income paid',
        tax: 'Tax withheld',
        condition: 'Condition',
      },
    },
  },
  compensation: {
    title: 'Pay',
    plural: 'Employee pay',
    create: 'Set pay',
    fields: {
      employeeId: 'Employee',
      payBasis: 'Paid',
      rate: 'Rate (THB)',
      payMethod: 'Method',
      bank: 'Bank',
      bankAccount: 'Account no.',
      bankAccountName: 'Account name',
      socialSecurity: 'Social security',
      withholdTax: 'Withholding tax',
      bondTarget: 'Security deposit target (THB)',
      bondPerRun: 'Deposit taken per run (THB)',
      branchId: 'Branch',
      notes: 'Notes',
    },
    options: {
      payBasis: { monthly: 'Monthly', daily: 'Daily' },
      payMethod: { transfer: 'Bank transfer', cash: 'Cash' },
    },
    sections: { main: 'Pay', bank: 'Payment', deductions: 'Deductions', bond: 'Security deposit' },
    rateHint: { monthly: 'THB a month', daily: 'THB a day worked (paid every 15 days)' },
    privateHint: 'Only payroll and managers see this',
    bankFromApplication:
      'The bank account is filled in from their job application: check it against the bank book in their employee record',
    none: 'No pay set',
  },
  payItem: {
    title: 'Earning or deduction',
    plural: 'Earnings and deductions',
    create: 'Add item',
    fields: {
      code: 'Code',
      name: 'Name',
      kind: 'Kind',
      taxable: 'Counts as taxable income',
      wage: 'Counts as social security wage',
      irregular: 'Paid once (bonus, severance)',
      system: 'Calculated',
      status: 'Status',
      sortOrder: 'Order',
      notes: 'Notes',
    },
    options: { kind: { earning: 'Earning', deduction: 'Deduction' }, status: { active: 'Active', inactive: 'Inactive' } },
    hint: 'A deduction ticked "taxable income" or "social security wage" lowers that base (absence); one not ticked is taken after tax (an advance)',
  },
  payAdjustment: {
    title: 'Extra or deduction',
    plural: 'Extras and deductions',
    create: 'Add extra or deduction',
    fields: {
      employeeId: 'Employee',
      payItemId: 'Item',
      amount: 'Amount',
      repeat: 'Repeats',
      date: 'Date',
      endDate: 'Until month',
      branchId: 'Branch',
      createdByUserId: 'Recorded by',
      notes: 'Notes',
    },
    options: { repeat: { once: 'Once', monthly: 'Monthly' } },
    hint: "Once: in the run holding this date · Monthly: every month-end run from this date's month until the month given (empty: no end)",
  },
  tripRate: {
    title: 'Trip rate',
    plural: 'Trip rates',
    create: 'Add trip rate',
    fields: {
      vehicleType: 'Vehicle type',
      fromKm: 'From (km)',
      driverAmount: 'Driver (THB/trip)',
      helperAmount: 'Helper (THB/trip)',
      notes: 'Notes',
    },
    anyVehicle: 'Any vehicle',
    hint: 'A row applies from its distance up to the next row of the same vehicle type; types without rows of their own use "Any vehicle". Only jobs delivered in the period count',
  },
  fuelRate: {
    title: 'Fuel rate',
    plural: 'Fuel per km',
    create: 'Add fuel rate',
    fields: { vehicleType: 'Vehicle type', perKm: 'THB per km', notes: 'Notes' },
    hint: 'A delivery run’s distance comes from the odometer photos the driver takes leaving and back at the branch, times the vehicle type’s rate; types without rows of their own use "Any vehicle". Staff are paid it as fuel on the payslip, a contract driver as a line on the run’s bill',
  },
  payrollRun: {
    title: 'Pay run',
    plural: 'Pay runs',
    create: 'New pay run',
    fields: {
      name: 'Run',
      kind: 'Kind',
      month: 'Month',
      periodStart: 'From',
      periodEnd: 'To',
      title: 'Name',
      people: 'Pays',
      employeeIds: 'Employees',
      countsTime: 'Count working time',
      payDate: 'Pay day',
      status: 'Status',
      employeeCount: 'People',
      gross: 'Gross',
      deductions: 'Deductions',
      net: 'Net pay',
      calculatedAt: 'Calculated',
      submittedByUserId: 'Submitted by',
      submittedAt: 'Submitted',
      approvedByUserId: 'Approved by',
      approvedAt: 'Approved',
      paidAt: 'Paid',
      createdByUserId: 'Created by',
      notes: 'Notes',
    },
    options: {
      kind: { regular: 'Regular', special: 'Special' },
      people: { all: 'Everyone', daily: 'Day workers', chosen: 'Chosen people' },
      status: { draft: 'In progress', pending: 'Awaiting approval', approved: 'Approved', paid: 'Paid' },
    },
  },
  payslip: {
    title: 'Payslip',
    plural: 'Payslips',
    fields: {
      runId: 'Run',
      employeeId: 'Employee',
      userId: 'User account',
      branchId: 'Branch',
      payBasis: 'Paid',
      rate: 'Rate',
      days: 'Days',
      actualFrom: 'Time counted from',
      actualThrough: 'Time counted to',
      ahead: 'Paid ahead by the schedule',
      gross: 'Gross',
      deductions: 'Deductions',
      net: 'Net pay',
      taxable: 'Taxable income',
      ssoWage: 'Social security wage',
      sso: 'Social security',
      tax: 'Tax',
      lines: 'Lines',
      trips: 'Trips',
      runs: 'Delivery runs',
      removed: 'Removed lines',
      problems: 'To check',
      ytdTaxable: 'Taxable to date',
      ytdTax: 'Tax to date',
      ytdSso: 'Social security to date',
      payMethod: 'Method',
      bank: 'Bank',
      bankAccount: 'Account no.',
      status: 'Status',
      payDate: 'Pay day',
      notes: 'Notes',
    },
    problems: {
      noBankAccount: 'No bank account',
      noTrips: 'No trips this period',
      unratedTrip: 'A trip has no rate',
      noDistance: 'A delivery run has no odometer readings, so no fuel pay yet',
      unratedRun: 'A delivery run’s vehicle type has no fuel rate',
      overDeduction: 'Deductions over a fifth of pay (section 76)',
      negativeNet: 'Net pay below zero',
      incomplete: 'Days with a missing clock-out',
      noIdCard: 'No ID card number (needed for tax and social security)',
      cashHeld: 'Final payslip, but collections or petty cash are still held: settle them before approving',
      bondNoAccount: 'A deposit target is set but there is no account to hold it, so nothing is taken (create one on the employee in HR)',
      bondLate:
        'Pay day is more than 7 days after their last day: accounting pays the deposit back first (section 10), then calculate again',
    },
  },
  taxDeclaration: {
    title: 'Tax allowances',
    plural: 'Tax allowances (L.Y.01)',
    create: 'Add tax allowances',
    fields: {
      employeeId: 'Employee',
      year: 'Tax year',
      spouse: 'Spouse without income',
      children: 'Children',
      childrenFrom2018: 'Of them, second and later born from 2018',
      parents: 'Parents and parents-in-law aged 60 and over',
      disabled: 'Disabled dependants',
      lifeInsurance: 'Life insurance premium',
      healthInsurance: 'Health insurance premium',
      parentsHealthInsurance: "Parents' health insurance",
      providentFund: 'Provident fund contributions',
      homeLoanInterest: 'Home loan interest',
      other: 'Other allowances (RMF, ThaiESG, donations…)',
      openingIncome: 'Income paid already',
      openingTax: 'Tax withheld already',
      openingSso: 'Social security taken already',
      total: 'Total allowances',
      userId: 'User account',
      notes: 'Notes',
    },
    sections: {
      main: 'Allowances',
      family: 'Family',
      insurance: 'Insurance and funds',
      other: 'Other',
      opening: 'Brought forward (payroll)',
    },
    openingHint:
      "Starting mid-year: what the company paid and took since January, before the first payslip here. Counted in the year's tax and on the 50 bis",
    hint: 'The personal allowance (60,000), the 50% expense deduction (up to 100,000) and social security are counted already',
  },
  payrollSetting: {
    title: 'Payroll settings',
    fields: {
      ssoRate: 'Social security rate (%)',
      ssoMinWage: 'Lowest wage counted',
      ssoMaxWage: 'Highest wage counted',
      ssoAccount: 'Employer social security account',
      ssoBranch: 'Branch no.',
      cutoffDay: 'Cut-off day',
      deductLate: 'Deduct lateness (by the minute, monthly staff)',
      advancePercent: 'Advances up to (% of pay earned)',
    },
    sections: { run: 'Pay runs', sso: 'Social security', time: 'Working time', advance: 'Salary advances' },
    sectionHints: {
      run: 'One run a month for everyone: salaries for the whole month, what goes by time (day wages, overtime, absence, leave, lateness, trips) up to the cut-off day. Empty: the month’s end; 25: the 26th of last month to the 25th. Changed, the next run goes on from the last one by itself.',
    },
    hint: '2026–2028: the highest wage counted is 17,500 (875 a month at most)',
  },
} as const
